module.exports = __webpack_public_path__ + "img/notifications/graph-76798a0d49f8df5d1fbab98507528c2f.svg";